import { render, staticRenderFns } from "./QualificationForm.vue?vue&type=template&id=bc488638&scoped=true"
import script from "./QualificationForm.vue?vue&type=script&lang=js"
export * from "./QualificationForm.vue?vue&type=script&lang=js"
import style0 from "./QualificationForm.vue?vue&type=style&index=0&id=bc488638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc488638",
  null
  
)

export default component.exports